/**
 * Returns the parent element of a trigger element for dropdown positioning
 * without detaching it from the DOM hierarchy.
 *
 * This function is used with Ant Design's getPopupContainer prop to ensure
 * dropdowns remain properly positioned relative to their parent elements,
 * preventing z-index and positioning issues that can occur when dropdowns
 * are rendered directly in the document body.
 *
 * @param trigger - The HTML element that triggered the dropdown
 * @returns The parent element of the trigger or document body as fallback
 */
export default function getDropdownParentWithoutDetaching(
  trigger: HTMLElement
) {
  return trigger?.parentElement || document.body;
}
